import { render, staticRenderFns } from "./email.vue?vue&type=template&id=eb477ae8&scoped=true&"
import script from "./email.vue?vue&type=script&lang=ts&"
export * from "./email.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb477ae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb477ae8')) {
      api.createRecord('eb477ae8', component.options)
    } else {
      api.reload('eb477ae8', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=eb477ae8&scoped=true&", function () {
      api.rerender('eb477ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/form/field/email.vue"
export default component.exports